import React, { useEffect, useRef, useState } from "react";
import EmailSvg from "../assets/images/svg/email-svg.svg";
import HomeSvg from "../assets/images/svg/home-svg.svg";
import AboutSvg from "../assets/images/svg/about-svg.svg";
import ResumeSvg from "../assets/images/svg/resume-svg.svg";
import ServicesSvg from "../assets/images/svg/services-svg.svg";
import PortfolioSvg from "../assets/images/svg/portfolio-svg.svg";
import ContactSvg from "../assets/images/svg/contact-svg.svg";
import DeveloperImg from "../assets/images/Developer.webp";
import HarbhajanSinghImg from "../assets/images/HarbhajanSingh.webp";
import BrandLogo1 from "../assets/images/Website1 (1).webp";
import BrandLogo2 from "../assets/images/Website1 (2).webp";
import BrandLogo3 from "../assets/images/Website1 (3).webp";
import BrandLogo4 from "../assets/images/Website1 (4).webp";
import BrandLogo5 from "../assets/images/Website1 (5).webp";
import BrandLogo6 from "../assets/images/Website1 (6).webp";
import BrandLogo7 from "../assets/images/Website1 (7).webp";
import BrandLogo8 from "../assets/images/Website1 (8).webp";
import BrandLogo9 from "../assets/images/Website1 (9).webp";
import BrandLogo10 from "../assets/images/Website1 (10).webp";
import BrandLogo11 from "../assets/images/Website1 (11).webp";
import AboutSection from "./About";
import Resume from "./Resume";
import Services from "./Services";
import WhatsAppSvg from "../assets/images/whatsapp_2504957.svg";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import $ from "jquery";
import CV from "../assets/pdf/HARBHAJAN SINGH.pdf";
import { Link } from "react-router-dom";
const Home = () => {
  //Text
  const firstTexts = ["Developer", "Freelancer"];
  const secondTexts = [
    "Freelancer",
    "Web Developer",
    "Full Stack Developer",
  ];
  const intervalTime = 600;

  const [firstTextIndex, setFirstTextIndex] = useState(0);
  const [secondTextIndex, setSecondTextIndex] = useState(0);

  useEffect(() => {
    const firstTextTimeout = setTimeout(() => {
      setFirstTextIndex((prevIndex) => (prevIndex + 1) % firstTexts.length);
    }, intervalTime * 3);

    return () => clearTimeout(firstTextTimeout);
  }, [firstTextIndex]);

  useEffect(() => {
    const secondTextTimeout = setTimeout(() => {
      setSecondTextIndex((prevIndex) => (prevIndex + 1) % secondTexts.length);
    }, intervalTime * 3);

    return () => clearTimeout(secondTextTimeout);
  }, [secondTextIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFirstTextIndex((prevIndex) => (prevIndex + 1) % firstTexts.length);
      setSecondTextIndex((prevIndex) => (prevIndex + 1) % secondTexts.length);
    }, intervalTime * 7);

    return () => clearInterval(interval);
  }, []);

  // Logo marquee
  useEffect(() => {
    const logosContainer = document.querySelector(".logos");
    if (logosContainer && !logosContainer.querySelector(".logos-slide.clone")) {
      const slide = logosContainer.querySelector(".logos-slide");
      const clone = slide.cloneNode(true);
      clone.classList.add("clone");
      logosContainer.appendChild(clone);
    }
  }, []);

  // Toggle Btn
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const menuToggle = document.getElementById("menu-toggle");
    const sideMenu = document.querySelector(".side-menu");
    const menuItems = document.querySelectorAll(".menu-list-main li");

    const handleMenuToggle = () => {
      setMenuOpen(!menuOpen);
      menuToggle.classList.toggle("open");
      sideMenu.classList.toggle("show");
    };

    const handleMenuItemClick = (event) => {
      event.preventDefault();
      const linkElement = event.currentTarget.querySelector("a");
      if (linkElement) {
        const targetId = linkElement.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
        setMenuOpen(false);
        menuToggle.classList.remove("open");
        sideMenu.classList.remove("show");
      }
    };

    if (menuToggle && sideMenu && menuItems.length > 0) {
      menuToggle.addEventListener("click", handleMenuToggle);
      menuItems.forEach((item) => {
        item.addEventListener("click", handleMenuItemClick);
      });

      $(".hamburger").click(function () {
        $(this).toggleClass("is-active");
      });

      return () => {
        menuToggle.removeEventListener("click", handleMenuToggle);
        menuItems.forEach((item) => {
          item.removeEventListener("click", handleMenuItemClick);
        });
      };
    }
  }, [menuOpen]);

  const [activeLink, setActiveLink] = useState("");

  const handleClick = (event, id) => {
    event.preventDefault();
    setActiveLink(id);
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <button id="menu-toggle" className="menu-toggle-button">
        <span className="hamburger" id="hamburger-1">
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </span>
      </button>
      {/* <!-- ====================================== Side Menu ===================================== --> */}
      <div className="side-menu">
        <div className="profile-img-main">
          <img className="zoom_in" src={DeveloperImg} alt="profile-img" />
          <h1 className="fade_up">
            <span>Harbhajan Singh</span>
          </h1>
          <h2 className="designer fade_up">{firstTexts[firstTextIndex]}</h2>
        </div>
        <div className="menu-list-main">
          <ul>
            <li
              className={`active-menu-action ${activeLink === "home" ? "active" : ""
                }`}
            >
              <a
                className="fade_right"
                href="#home"
                onClick={(e) => handleClick(e, "home")}
              >
                <img src={HomeSvg} alt="home-svg" />
                Home
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "about" ? "active" : ""
                }`}
            >
              <a
                className="fade_right"
                href="#about"
                onClick={(e) => handleClick(e, "about")}
              >
                <img src={AboutSvg} alt="about-svg" />
                About
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "resume" ? "active" : ""
                }`}
            >
              <a
                className="fade_right"
                href="#resume"
                onClick={(e) => handleClick(e, "resume")}
              >
                <img src={ResumeSvg} alt="resume-svg" />
                Resume
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "services" ? "active" : ""
                }`}
            >
              <a
                className="fade_right"
                href="#services"
                onClick={(e) => handleClick(e, "services")}
              >
                <img src={ServicesSvg} alt="services-svg" />
                Services
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "portfolio" ? "active" : ""
                }`}
            >
              <a
                className="fade_right"
                href="#portfolio"
                onClick={(e) => handleClick(e, "portfolio")}
              >
                <img src={PortfolioSvg} alt="portfolio-svg" />
                Portfolio
              </a>
            </li>

            <li
              className={`active-menu-action ${activeLink === "contact" ? "active" : ""
                }`}
              id="contact-line"
            >
              <a
                className="fade_right"
                href="#contact"
                onClick={(e) => handleClick(e, "contact")}
              >
                <img src={ContactSvg} alt="contact-svg" />
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div id="wrap">
            <Link
              to={CV}
              rel="noreferrer"
              target="_blank"
              className="btn-slide"
            >
              <span className="circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    className="download-svg"
                    d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span className="title">Download CV</span>
              <span className="title-hover">Click Here</span>
            </Link>{" "}
          </div>
        </div>
      </div>

      {/* <!-- ====================================== Side Menu End ===================================== --> */}
      <div className="main-containe" data-bs-spy="scroll">
        {/* <!-- ====================================== Section One ===================================== --> */}
        <section className="section-one overflow-hidden" id="home">
          <div className="row">
            <div className="col-xxl-6 col-lg-6">
              <h2 className="jessica-main-text zoom_in">
                Harbhajan Singh
              </h2>
              <h3 className="back-End-dev designer2">
                {secondTexts[secondTextIndex]}
              </h3>
              <p className="best fade_down">
                We deeply value the trust our clients place in us. They choose our products and services because of our commitment to quality, reliability, and excellence. Every project is handled with professionalism and care, ensuring outstanding results. Our reputation is built on delivering the best solutions and creating long-term relationships with clients worldwide.
              </p>
              <div className="section-one-btns-main fade_down">
                <div className="wrapper">
                  <Link className="btn-hover" to="#" onClick={(e) => handleClick(e, "portfolio")}>
                    View Work
                  </Link>
                </div>
                <div className="wrapper">
                  <Link className="btn-hover btn-hover2" to="tel:+916283505181">
                    Contact Me
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-lg-6 position-relative">
              <img
                className="jessica-main-img zoom_in"
                src={HarbhajanSinghImg}
                alt="harbhajan-singh"
              />
            </div>
          </div>
        </section>
        {/* <!-- ====================================== Section Marquee ===================================== --> */}
        <section className="Marquee-main overflow-hidden">
          <h2 className="section-heading-text about-me fade_up show">Trusted by My Clients</h2>
          <div className="logos logos2">
            <div className="logos-slide">
              <div className="marquee__content">
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo1}
                    alt="brand-logo1"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo2}
                    alt="brand-logo2"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo3}
                    alt="brand-logo3"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo4}
                    alt="brand-logo4"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo5}
                    alt="brand-logo5"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo6}
                    alt="brand-logo6"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo7}
                    alt="brand-logo7"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo8}
                    alt="brand-logo8"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo9}
                    alt="brand-logo9"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo10}
                    alt="brand-logo10"
                  />
                </div>
                <div className="marquee-img-main">
                  <img
                    className="brand-logos"
                    src={BrandLogo11}
                    alt="brand-logo11"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- ====================================== Section Marquee End ===================================== --> */}
        {/* <!-- ====================================== Section About ===================================== --> */}
        <AboutSection />
        {/* <!-- ====================================== Section About End ===================================== --> */}
        {/* <!-- ====================================== Section Education Experience ===================================== --> */}
        <Resume />
        {/* <!-- ====================================== Section Education Experience End ===================================== --> */}
        {/* <!-- ====================================== Section Services ===================================== --> */}
        <Services />
        {/* <!-- ====================================== Section Services ===================================== --> */}
        {/* <!-- ====================================== Section Portfolio ===================================== --> */}
        <Portfolio />
        {/* <!-- ====================================== Section Portfolio ===================================== --> */}
        {/* <!-- ====================================== Section Contact ===================================== --> */}
        <Contact />
        {/* <!-- ====================================== Section Contact ===================================== --> */}
      </div>
      <a
        href="https://wa.me/916283505181?text=I%20am%20Harbhajan%20Singh%2C%20how%20can%20I%20help%20you%3F"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={WhatsAppSvg} alt="WhatsApp" />
      </a>
    </>
  );
};
export default Home;
